import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import _wrapNativeSuper from "@babel/runtime/helpers/esm/wrapNativeSuper";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
export var GooglePSEService = /*#__PURE__*/ function () {
    function GooglePSEService(config) {
        /* this.firebaseFunctionUrl = config?.firebaseFunctionUrl ||
          (process.env.NODE_ENV === 'development'
            ? 'http://localhost:5001/makroskop-b14f3/europe-west1/googlePSESearch'
            : 'https://europe-west1-makroskop-b14f3.cloudfunctions.net/googlePSESearch'); */
        this.firebaseFunctionUrl = 'https://europe-west1-makroskop-b14f3.cloudfunctions.net/googlePSESearch';
    }
    var _proto = GooglePSEService.prototype;
    _proto.search = /*#__PURE__*/ function () {
        var _search = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee(params) {
            var response, errorData, data;
            return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            _context.next = 3;
                            return fetch(this.firebaseFunctionUrl, {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json'
                                },
                                body: JSON.stringify(params)
                            });
                        case 3:
                            response = _context.sent;
                            if (response.ok) {
                                _context.next = 9;
                                break;
                            }
                            _context.next = 7;
                            return response.json();
                        case 7:
                            errorData = _context.sent;
                            throw new GooglePSEApiError(response.status, errorData.error || "HTTP " + response.status + ": " + response.statusText);
                        case 9:
                            _context.next = 11;
                            return response.json();
                        case 11:
                            data = _context.sent;
                            return _context.abrupt("return", data);
                        case 15:
                            _context.prev = 15;
                            _context.t0 = _context["catch"](0);
                            if (!(_context.t0 instanceof GooglePSEApiError)) {
                                _context.next = 19;
                                break;
                            }
                            throw _context.t0;
                        case 19:
                            throw new GooglePSEApiError(500, "Network error: " + _context.t0.message);
                        case 20:
                        case "end":
                            return _context.stop();
                    }
                }
            }, _callee, this, [[0, 15]]);
        }));
        function search(_x) {
            return _search.apply(this, arguments);
        }
        return search;
    }() //Search with automatic retry logic
    ;
    _proto.searchWithRetry =
        /*#__PURE__*/
        function () {
            var _searchWithRetry = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee2(params, maxRetries) {
                var lastError, attempt;
                return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (maxRetries === void 0) {
                                    maxRetries = 3;
                                }
                                attempt = 1;
                            case 2:
                                if (!(attempt <= maxRetries)) {
                                    _context2.next = 19;
                                    break;
                                }
                                _context2.prev = 3;
                                _context2.next = 6;
                                return this.search(params);
                            case 6:
                                return _context2.abrupt("return", _context2.sent);
                            case 9:
                                _context2.prev = 9;
                                _context2.t0 = _context2["catch"](3);
                                lastError = _context2.t0 instanceof GooglePSEApiError ? _context2.t0 : new GooglePSEApiError(500, _context2.t0.message);
                                if (!(attempt === maxRetries || lastError.code === 400)) {
                                    _context2.next = 14;
                                    break;
                                }
                                return _context2.abrupt("break", 19);
                            case 14:
                                _context2.next = 16;
                                return this.delay(Math.pow(2, attempt) * 1000);
                            case 16:
                                attempt++;
                                _context2.next = 2;
                                break;
                            case 19:
                                throw lastError;
                            case 20:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, this, [[3, 9]]);
            }));
            function searchWithRetry(_x2, _x3) {
                return _searchWithRetry.apply(this, arguments);
            }
            return searchWithRetry;
        }() //Get paginated search results
    ;
    _proto.searchPaginated =
        /*#__PURE__*/
        function () {
            var _searchPaginated = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee3(params, page, pageSize) {
                var start;
                return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                if (page === void 0) {
                                    page = 1;
                                }
                                if (pageSize === void 0) {
                                    pageSize = 10;
                                }
                                start = (page - 1) * pageSize + 1;
                                return _context3.abrupt("return", this.search(Object.assign({}, params, {
                                    start: start,
                                    num: pageSize
                                })));
                            case 4:
                            case "end":
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));
            function searchPaginated(_x4, _x5, _x6) {
                return _searchPaginated.apply(this, arguments);
            }
            return searchPaginated;
        }();
    _proto.delay = function delay(ms) {
        return new Promise(function (resolve) {
            return setTimeout(resolve, ms);
        });
    };
    return GooglePSEService;
}();
export var GooglePSEApiError = /*#__PURE__*/ function (_Error) {
    _inheritsLoose(GooglePSEApiError, _Error);
    function GooglePSEApiError(code, message) {
        var _this;
        _this = _Error.call(this, message) || this;
        _this.code = code;
        _this.name = 'GooglePSEApiError';
        return _this;
    }
    return GooglePSEApiError;
}(/*#__PURE__*/ _wrapNativeSuper(Error)); // Default instance factory - no longer needs API config
export var createGooglePSEService = function createGooglePSEService(config) {
    return new GooglePSEService(config);
};
